import { render, staticRenderFns } from "./StatisticPerformance.vue?vue&type=template&id=09f262ae&"
import script from "./StatisticPerformance.vue?vue&type=script&lang=ts&"
export * from "./StatisticPerformance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports